<template>
    <PageHeaderDropdown faIconClass="fa fa-ellipsis-h" v-if="hasCtas">
        <template v-slot:content>
            <div
                class="dropdown-content relative tw-z-[2000] tw-flex tw-min-w-[256px] tw-flex-col"
            >
                <CtaResolver :ctas="ctas" inDropdown />
            </div>
        </template>
    </PageHeaderDropdown>
</template>

<script setup>
import { computed } from "vue";
import PageHeaderDropdown from "./PageHeaderDropdown.vue";
import CtaResolver from "./Ctas/CtaResolver.vue";

const props = defineProps({
    ctas: {
        type: Array,
        default: () => [],
    },
});

const hasCtas = computed(() => props.ctas && props.ctas.length > 0);
</script>
